import React, { Component } from "react";
import { Row, Col, Alert, Button, Container, Label, Spinner } from "reactstrap"; // Make sure Spinner is imported

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { forgetUser } from "../../store/actions";

// import images
import logodark from "../../assets/images/logo-dark.png";
import withRouter from "../../components/Common/withRouter";
import { saveRecords } from "../../services/api.service";
import { toast } from "react-toastify";

class ForgetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  async handleValidSubmit(event, values) {
    this.setState({ loading: true });

    try {
      const response = await saveRecords(values, "/auth/forget_password");

      if (response.code === 1) {
        toast.success(response.message);
      } else if (response.code === 0) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div>
          {this.state.loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner size="lg" color="primary" />
              </div>
            </div>
          )}

          <Container fluid className="p-0">
            <Row className="g-0">
              <Col lg={4}>
                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                  <div className="w-100">
                    <Row className="justify-content-center">
                      <Col lg={9}>
                        <div>
                          <div className="text-center">
                            <div>
                              <Link to="/" className="logo">
                                <img
                                  src={
                                    "https://www.bermad.com/app/uploads/Bermad-logo-new.png"
                                  }
                                  height="100"
                                  alt="logo"
                                />
                              </Link>
                            </div>

                            <h4 className="font-size-18 mt-4">
                              Reset Password
                            </h4>
                          </div>

                          <div className="p-2 mt-5">
                            {this.props.forgetError &&
                              this.props.forgetError ? (
                              <Alert color="danger" className="mb-4">
                                {this.props.forgetError}
                              </Alert>
                            ) : null}
                            {this.props.message ? (
                              <Alert color="success" className="mb-4">
                                {this.props.message}
                              </Alert>
                            ) : null}
                            <AvForm
                              className="form-horizontal"
                              onValidSubmit={this.handleValidSubmit}
                            >
                              <div className="auth-form-group-custom mb-4">
                                <i className="ri-mail-line auti-custom-input-icon"></i>
                                <Label htmlFor="email">Email</Label>
                                <AvField
                                  name="email"
                                  value={this.state.username}
                                  type="email"
                                  validate={{
                                    required: {
                                      value: true,
                                      errorMessage: "Username is required",
                                    },

                                    pattern: {
                                      value:
                                        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                                      errorMessage:
                                        "Please enter the valid mail id",
                                    },
                                  }}
                                  className="form-control"
                                  id="email"
                                  placeholder="Enter email"
                                />
                              </div>

                              <div className="mt-4 text-center">
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="submit"
                                  style={{
                                    background: '#006eb9'
                                  }}
                                >
                                  {this.state.loading ? "Loading..." : "Reset"}
                                </Button>
                              </div>
                            </AvForm>
                          </div>

                          <div className="mt-5 text-center">
                            <p>
                              Don't have an account ?{" "}
                              <Link to="/" className="fw-medium text-primary">
                                {" "}
                                Log in{" "}
                              </Link>{" "}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col lg={8}>
                <div className="bermad-wallpaper">
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { message, forgetError, loading } = state.Forget;
  return { message, forgetError, loading };
};

export default withRouter(
  connect(mapStatetoProps, { forgetUser })(ForgetPasswordPage)
);
